import { useCallback, useMemo, useState } from 'react';
import type { Lot } from 'venn-api';
import type { SearchMenuItem } from '../../search-menu';

export const useAllocationPanelSearchSelection = (
  onMultiSelectFund: (items: SearchMenuItem[], allocations?: Map<string, number>, lots?: Map<string, Lot[]>) => void,
) => {
  const [selectedItems, setSelectedItems] = useState<SearchMenuItem[]>([]);

  const filteredSelectedItems = useMemo(
    () => selectedItems.filter((item) => !(item.searchResult?.tagIds?.length ?? 0)),
    [selectedItems],
  );

  const onMultiSelectSubmit = useCallback(
    (items: SearchMenuItem[], allocations?: Map<string, number>, lots?: Map<string, Lot[]>) => {
      onMultiSelectFund(items, allocations, lots);
    },
    [onMultiSelectFund],
  );

  const onAddSelection = useCallback(() => {
    onMultiSelectSubmit(filteredSelectedItems);
  }, [filteredSelectedItems, onMultiSelectSubmit]);

  return {
    setSelectedItems,
    filteredSelectedItems,
    onMultiSelectSubmit,
    onAddSelection,
  };
};
